"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_request_1 = require("graphql-request");
const bifrost_number_1 = __importDefault(require("@bifrost-platform/bifrost-number"));
class TokenLiquidity {
    constructor() {
        this.price = '0';
        this.liquidity = '0';
    }
}
class DexRpc {
    constructor(host) {
        this.graphQLClient = new graphql_request_1.GraphQLClient(host, { headers: {} });
    }
    getEthPrice() {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await this.graphQLClient.request(DexRpc.ethPriceQuery)) || {};
                resolve((response.bundle || {}).ethPrice || '0');
            }
            catch (error) {
                reject(error);
            }
        });
    }
    getTokenPrice(address) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await this.graphQLClient.request(DexRpc.getTokenQuery(address))) || {};
                const ethPrice = new bifrost_number_1.default((response.bundle || {}).ethPrice || '0');
                const derivedETH = new bifrost_number_1.default((response.token || {}).derivedETH || '0');
                const result = ethPrice.mul(derivedETH).toStr();
                resolve(result);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    getTokenPriceByPair(pairAddress) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await this.graphQLClient.request(DexRpc.getTokenByPairQuery(pairAddress))) || {};
                const ethPrice = new bifrost_number_1.default((response.bundle || {}).ethPrice || '0');
                const derivedETH = new bifrost_number_1.default(((response.pair || {}).token0 || {}).derivedETH || '0');
                const result = ethPrice.mul(derivedETH).toStr();
                resolve(result);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    getPairTokenLiquidities(address) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = (await this.graphQLClient.request(DexRpc.getPairTokenQuery(address))) || {};
                const ethPrice = new bifrost_number_1.default((response.bundle || {}).ethPrice || '0');
                const derivedETH0 = new bifrost_number_1.default(((response.pair || {}).token0 || {}).derivedETH || '0');
                const derivedETH1 = new bifrost_number_1.default(((response.pair || {}).token1 || {}).derivedETH || '0');
                const token0Price = ethPrice.mul(derivedETH0);
                const token1Price = ethPrice.mul(derivedETH1);
                const totalSupply = new bifrost_number_1.default((response.pair || {}).totalSupply || '0');
                const reserve0 = new bifrost_number_1.default((response.pair || {}).reserve0 || '0');
                const reserve1 = new bifrost_number_1.default((response.pair || {}).reserve1 || '0');
                const a = totalSupply.gt('0') ? reserve0.div(totalSupply) : new bifrost_number_1.default('0');
                const b = totalSupply.gt('0') ? reserve1.div(totalSupply) : new bifrost_number_1.default('0');
                const result = [{
                        price: token0Price.toStr(),
                        liquidity: a.toStr()
                    }, {
                        price: token1Price.toStr(),
                        liquidity: b.toStr()
                    }];
                resolve(result);
            }
            catch (error) {
                reject(error);
            }
        });
    }
    getPairTokenPriceByTokenLiquidities(tokenLiquidities) {
        const a = tokenLiquidities[0] || new TokenLiquidity();
        const b = tokenLiquidities[1] || new TokenLiquidity();
        const result = new bifrost_number_1.default(a.liquidity).mul(a.price).plus(new bifrost_number_1.default(b.liquidity).mul(b.price)).toStr();
        return result;
    }
    getPairTokenPrice(address) {
        return new Promise(async (resolve, reject) => {
            try {
                resolve(this.getPairTokenPriceByTokenLiquidities((await this.getPairTokenLiquidities(address))
                    || [])
                    || '0');
            }
            catch (error) {
                reject(error);
            }
        });
    }
    static getTokenQuery(address) {
        return graphql_request_1.gql `{
      bundle(id: "1" ) {
        ethPrice
      }
      token(id: "${address}") {
        derivedETH
      }
    }`;
    }
    static getTokenByPairQuery(pairAddress) {
        return graphql_request_1.gql `{
      bundle(id: "1" ) {
        ethPrice
      }
      pair(id: "${pairAddress}") {
        token0 {
          derivedETH
        }
      }
    }`;
    }
    static getPairTokenQuery(address) {
        return graphql_request_1.gql `{
      bundle(id: "1" ) {
        ethPrice
      }
      pair(id: "${address}") {
        token0 {
          derivedETH
        }
        token1 {
          derivedETH
        }
        reserve0
        reserve1
        totalSupply
      }
    }`;
    }
}
exports.default = DexRpc;
DexRpc.ethPriceQuery = graphql_request_1.gql `{
    bundle(id: "1" ) {
      ethPrice
    }
  }`;
//# sourceMappingURL=DexRpc.js.map